import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Link from '../../utils/link';
import Typography from '../../atoms/typography';

const Container = styled.section`
  font-family: ${(props) => props.theme.font.sans};
  font-size: 1.4rem;
  text-align: center;
  width: 100%;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    display: flex;
    text-align: left;
  }
`;

const Label = styled(Typography)`
  align-items: baseline;
  color: ${(props) => props.theme.color.brand};
  display: inline-flex;
  text-transform: uppercase;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    padding-right: 20px;
    flex: 0 1 auto;
  }
`;

const Products = styled.ul`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1 1 auto;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    flex-direction: row;
  }
`;

const ProductLink = styled.li`
  a {
    color: ${(props) => props.theme.color.brandLight};
    cursor: pointer;
    text-decoration: none;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    padding-right: 12px;
  }
`;

const ProductText = (props) => (
  <Container>
    <Label element="h3" like="dec-1">Shop</Label>
    <Products>
      {
        Object.entries(props.products).map((productElem) => {
          /* eslint-disable-next-line no-unused-vars */
          const [key, value] = productElem;
          const productData = Object.values(value)[0];
          return (
            <ProductLink key={productData.product_slug}>
              <Link href={`/product/${productData.product_slug}`} passHref>
                <a>
                  { /* eslint-disable-next-line prefer-template */ }
                  { `${productData.title}${productData.brand ? `, ${productData.brand}` : ''};` }
                </a>
              </Link>
            </ProductLink>
          );
        })
      }
    </Products>
  </Container>
);

ProductText.propTypes = {
  products: PropTypes.object.isRequired
};

export default ProductText;
